import '../indexAdmin.css';

import { useContext } from "react";
import { Outlet } from "react-router-dom";
import { AuthContext } from "../context/authContext";
import { ConfigProvider } from "../context/configContext";

import Loading from "../components/Loading";
import Menu from "../components/Menu";
import Login from "./login";


const Admin = () => {
    const { user } = useContext(AuthContext);

    if (user === null) {
        return (<Loading />)
    }

    if (!user) {
        return (<Login />)
    }

    return (
        <div className="d-flex h100 bg-light">
            <Menu />
            <div className="flex-grow-1">
                <ConfigProvider >
                    <Outlet />
                </ConfigProvider>
            </div>
        </div>
    )

}

export default Admin;